import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { QuestionnaireService } from "app/services/questionnaire.service";
import { NgxSpinnerService } from "ngx-spinner";
import { HelperService } from "app/services/helper.service";
import { TosterMessageService } from "app/services/toster-message.service";
import { NgForm } from "@angular/forms";
import { QuestionBankService } from "../../services/question-bank.service";
import { UploadService } from "app/services/upload.service";

@Component({
  selector: "app-question-bank-add-new.component-modal",
  templateUrl: "./question-bank-add-new.component-modal.component.html",
  styleUrls: ["./question-bank-add-new.component-modal.component.scss"],
  providers: [QuestionBankService],
})
export class QuestionBankNewQueAddModalComponent implements OnInit {
    
  isHide: any = 1;

  public masterData: any = {};
  formData = {
    correct_answer: "",
    answer: "",
    media_type: "",
    media_link: "",
    marks: "",
    auto_id: "",
  };
  activeStatus = [
    { value: 1, label: "Yes" },
    // { value: 0, label: "No" },
  ];
  alterType = [
    { value: 0, label: "No" },
    // { value: 1, label: "Yes" },
  ];
  answerType = [
    { value: 0, label: "No" },
    { value: 1, label: "Yes" },
  ];

  isLoading = false;
  
  isEdit: number;
  @Output() tableReload: EventEmitter<any> = new EventEmitter();
  @Input() auto_id: number;

  @ViewChild("form") form: NgForm;
  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;

  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  selectedCompanySystemID = this.helperService.getSelectedCompanyId();
  companySystemID = +this.helperService.getSelectedCompanyId();

  constructor(
    public bsModalRef: BsModalRef,
    private helperService: HelperService,
    private modalService: BsModalService,
    private QuestionBankService: QuestionBankService,
    private UploadService: UploadService
  ) {}

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("designation_closed");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("designation_closed");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  ngOnInit() {
    this.auto_id = Number(localStorage.getItem("question-bank-edit-auto-id"));
    localStorage.removeItem("question-bank-edit-auto-id");

    localStorage.removeItem("file");
    setInterval(()=> { 
      if(localStorage.getItem("file")){
        this.isLoading = false;
      }
    }, 1500);
  }


  onQuestionTypeChange($event) {
    //console.log($event.target.value);
      if ($event.target.value !== '3') {
          this.isHide = 0;
      } else {
        this.isHide = 1;
      }

    // if (selectedValue === '1' || selectedValue === '2' || selectedValue === '4') {
    //   this.formData.media_type = selectedValue; 
    // } else {
    //   this.formData.media_type = '0'; 
    // }
  }


  ngOnChanges(changes: SimpleChanges): void {
    this.isLoading = false;
  }

  selectedFile: any = {};

  async onFileSelected(event: any) {
    this.isLoading = true;
    this.selectedFile = event.target.files[0];
    let response: any = await this.UploadService.uploadFile(this.selectedFile);
    // //console.log(response);
  }


  addNewQuestion(formData: any) {
    const requestData = {
      qiz_type_id: formData.qiz_type_id,
      marks: formData.marks,
      question: formData.question,
      // can_type_answer: formData.can_type_answer,
      // can_alter_quesion: formData.can_alter_quesion,
      can_type_answer: '1',
      can_alter_quesion: '0',
      sort: formData.sort,
      company_id: this.companySystemID,
      header_id: this.auto_id,
      media_link: localStorage.getItem("file"),
      active: 1,
    };

    //console.log(requestData);
    localStorage.removeItem("file");

    let that = this;
    that.masterData.companySystemID = that.companySystemID;
    that.masterData.header_id = that.auto_id;
    that.QuestionBankService.createNewQuestionBank()
      .post(requestData)
      .subscribe(
        (resp: any) => {
          //console.log(resp);
          that.masterData = {};
          that.successMsg = "";
          that.successMsg = "Successfully added a new question";
          that.showSuccessHtml();
          that.closeModalAfterCreate();
          this.tableReload.emit();
        },
        (error) => {
          that.htmlErrorMessage = "";
          if (error.status == 500) {
            that.htmlErrorMessage = error.data.message;
            that.showErrorHtml();
          } else if (error.status == 422) {
            that.htmlErrorMessage = that.helperService.serverSideError422(error.data.message);
            that.showErrorHtml();
          }
          this.tableReload.emit();
        }
      );
  }
}



// WEBPACK FOOTER //
// /app/src/app/competancy/question-bank-add-new.component-modal/question-bank-add-new.component-modal.component.ts